// extracted by mini-css-extract-plugin
export default {"responsive-grid-2":"duplicate-site_responsive-grid-2__UAp19","step-item":"duplicate-site_step-item__6c1Rj"};